import request from '@/utils/request'

//登录
export function login(data) {
  return request({
    url:'Login/check_login',
    method:'post',
    data
  })
}
//注册
export function getreg(data) {
  return request({
    url:'Login/reg',
    method:'post',
    data
  })
}

//省市区
export function getCity(data) {
  return request({
    url:'City/query_city',
    method:'post',
    data
  })
}


//
export function getInfo(data) {
  return request({
    url:'User/user_list',
    method:'post',
    data
  })
}
//
export function getimage(data) {
  return request({
    url:'Index/query_login_reg',
    method:'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/loginred.js